import jwt_decode from 'jwt-decode';

export const getTokenClaim = (token: string): Promise<Record<string, string>> =>
  new Promise((resolve, reject) => {
    if (!token) {
      reject(new Error('Missing cloud one token'));
      return;
    }
    const decodedToken = jwt_decode(token);
    if (typeof decodedToken !== 'object' || decodedToken === null) {
      throw new Error('Unable to decode claim, invalid token was received.');
    }
    resolve({ ...decodedToken });
  });

export const getSamlAuthToken = async (authCode = ''): Promise<Record<string, string>> => {
  if (authCode === '') {
    console.error('Error: Auth Code Missing');
    return {};
  }
  let samlTokensEndPoint;
  switch (DEPLOYMENT_TARGET) {
    case 'prod':
      samlTokensEndPoint = `https://saml.cloudone.trendmicro.com/api/tokens/${authCode}`;
      break;
    case 'stage':
      samlTokensEndPoint = `https://saml.staging-cloudone.trendmicro.com/api/tokens/${authCode}`;
      break;
    case 'drsim':
      samlTokensEndPoint = `https://saml.drsim-cloudone.trendmicro.com/api/tokens/${authCode}`;
      break;
    case 'govcloud-prod':
      samlTokensEndPoint = `https://saml.cloudonegov.trendmicro.com/api/tokens/${authCode}`;
      break;
    case 'govcloud-staging':
      samlTokensEndPoint = `https://saml.staging-cloudonegov.trendmicro.com/api/tokens/${authCode}`;
      break;
    case 'alpha':
    case 'dev':
      samlTokensEndPoint =
        window.location.hostname === 'localhost'
          ? `/api/tokens/${authCode}`
          : `https://saml.dev-cloudone.trendmicro.com/api/tokens/${authCode}`;
      break;
    default:
      samlTokensEndPoint = null;
      console.error('No SAML Tokens End-Point Found.');
  }

  try {
    const response = await fetch(samlTokensEndPoint, {
      headers: {
        'api-version': 'v1',
        'cache-control': 'no-cache',
      },
      method: 'POST',
      mode: 'cors',
    });

    const { access_token = '', message = '' } = await response.json();

    if (!response.ok || access_token === '') {
      throw new Error(message);
    }

    const tokenClaims = await getTokenClaim(access_token);
    window.history.replaceState({}, '', '/');

    return {
      access_token,
      ...tokenClaims,
    };
  } catch (e) {
    const errMsg = e.message ? e.message : e;
    console.error(errMsg);
    return errMsg;
  }
};
